import React, { Component } from 'react';
import Icon from '../../../icons/Icon';
import { RootState } from '../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { CaseReason } from '../../../domain/collection/rule/FlowDomains';
import FormicaInput from 'components/custom/FormicaInput';
import FormicaLabel from '../../custom/FormicaLabel';
import { customConfirm } from '../../custom/CustomPopupConfirm';
import LanguageUtil from '../../../util/LanguageUtil';
import { TokenVariable, VariableToken } from '@trlogic/ui-pack';
import { query, repository } from '@trlogic/client-js';
import CollectionNames from '../../../constant/CollectionNames';
import { TransactionJsonModel } from '../../../domain/stream/transaction/TransactionDomains';
import VariableType from '../../../constant/VariableType';
import _ from 'lodash';
import { EnrichmentBase } from '../../../domain/enrichment/EnrichmentDomain';
import { InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import CustomLoading from '../../custom/CustomLoading';
import WorkflowNodeUtil from '../../../util/WorkflowNodeUtil';
import { RuleAttachment } from '../../../domain/collection/rule/RuleDomains';
import ReadOnlyQueryableRepository = repository.ReadOnlyQueryableRepository;
import eq = query.eq;
import ComponentName from '../../../constant/ComponentName';

class ResolutionEditorComponent extends Component<Props, State> {
  public state: State = new State();

  private readonly repository: ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);

  public render() {
    const { attachmentValue, attachmentKey, loading } = this.state;

    if (loading) {
      return <CustomLoading />;
    }

    return (
      <div className={'flex flex-col w-full h-full border-[1px] border-[#E0E4E8] rounded-[12px] max-h-[300px]'}>
        <div className={'flex justify-start gap-x-1 items-center w-full min-h-[48px] border-b-[1px] border-[#E0E4E8] px-5 bg-main-gray rounded-t-[12px]'}>
          <Icon icon={'kyc_informationicon'} size={20} color={'#284564'} />
          <span className={'text-primary text-lg font-bold'}>
            {LanguageUtil.get({ id: 'common.label.resolutionAttachments', defaultMessage: 'Resolution Attachments' })}
          </span>
        </div>
        <div className={'flex gap-x-4 items-center pt-5 pb-4 justify-center px-4'}>
          <div className={'flex flex-col gap-y-1.5 w-full h-full items-start justify-center'}>
            <FormicaLabel label={LanguageUtil.get({ id: 'common.label.label', defaultMessage: 'Label' })} />
            <FormicaInput
              type={'text'}
              label={LanguageUtil.get({ id: 'common.input.placeholder.label', defaultMessage: 'Label' })}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.label', defaultMessage: 'Label' })}
              value={attachmentKey}
              onChange={this.handleKeyChange}
              data-testid={`${ComponentName.RULE}_attachment_create_key_input`}
            />
          </div>
          <div className={'flex flex-col gap-y-1.5 w-full h-full items-start justify-center'}>
            <FormicaLabel label={LanguageUtil.get({ id: 'common.label.value', defaultMessage: 'Value' })} />
            {/*
              <CustomInputEditor language="archios"
                                 variables={variables}
                                 value={attachmentValue}
                                 onChange={this.handleValueChange}
                                 containerStyle={{
                                   boxShadow: "0 0 0 0.2rem rgba(114, 142, 255, 0.25) !important",
                                   borderColor: "#E0E0E0",
                                   borderRadius: 4,
                                   padding: "0.5rem"
                                 }}/>
              */}
            <FormicaInput
              type={'text'}
              label={LanguageUtil.get({ id: 'common.label.value', defaultMessage: 'Value' })}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.value', defaultMessage: 'Value' })}
              value={attachmentValue}
              onChange={this.handleValueChange}
              data-testid={`${ComponentName.RULE}_attachment_create_value_input`}
            />
          </div>
          <div className={'flex h-full items-end justify-center'}>
            <button
              className={'flex px-1.5 py-1.5 box-border border-[1px] border-[#E0E4E8] rounded-[5px] items-center justify-center bg-primary'}
              onClick={this.handleAddAttachment}
              data-testid={`${ComponentName.RULE}_attachment_create_button`}
            >
              <Icon icon={'add'} size={20} className={'text-white'} />
            </button>
          </div>
        </div>
        <div className={'flex overflow-hidden w-full h-full border-t '}>{this.renderAttachments()}</div>
      </div>
    );
  }

  public async componentDidMount() {
    const {
      rule: { rule },
      selectedResolution,
    } = this.props;

    const selectedResolutionNode = rule.resolutions.length > 0 && rule.resolutions.find((resolution) => resolution.reason == selectedResolution);
    if (selectedResolutionNode) {
      this.setState({ attachments: selectedResolutionNode.attachments });
    }

    const variables: Record<string, TokenVariable[]> | undefined = await this.getVariables();
    this.setState({ variables: variables ?? {}, loading: false });
  }

  private getVariables = async () => {
    const { rule } = this.props;
    const eventName = WorkflowNodeUtil.getTransaction(rule.rule.workflow)?.value?.name;
    if (eventName == undefined) return;
    const eventQuery = query.QueryBuilder.select().from(CollectionNames.TRANSACTIONS).where(eq('name', eventName)).build();
    const events: any[] = (await this.repository.findMany<TransactionJsonModel>(eventQuery)).flatMap((e: TransactionJsonModel) => {
      return e.variables.map((v) => ({
        type: VariableType.EVENT_VARIABLE,
        variable: {
          type: 'Common Variable',
          variableType: VariableType.EVENT_VARIABLE,
          name: v.name,
          properties: v.properties,
          args: {
            event: e.name,
          },
        },
      }));
    });
    const previousEvents: any[] = (await this.repository.findMany<TransactionJsonModel>(eventQuery)).flatMap((e: TransactionJsonModel) => {
      return e.variables.map((v) => ({
        type: VariableType.PREVIOUS_EVENT_VARIABLE,
        variable: {
          type: 'Common Variable',
          variableType: VariableType.PREVIOUS_EVENT_VARIABLE,
          name: v.name,
          properties: v.properties,
          args: {
            event: e.name,
          },
        },
      }));
    });
    const enrichmentVariables: Record<
      Exclude<VariableType, VariableType.EVENT_VARIABLE | VariableType.ACTOR_VARIABLE | VariableType.PREVIOUS_EVENT_VARIABLE>,
      TokenVariable<VariableToken>[]
    > = _.groupBy(
      ((await this.repository.findMany(query.QueryBuilder.select().from(CollectionNames.ENRICHMENTS).build())) as EnrichmentBase[]).map((e) => ({
        type: e.type,
        variable: {
          type: 'Common Variable',
          variableType: e.type,
          name: e.name,
          properties: e.properties,
          args: {},
        },
      })),
      (e: any) => e.type,
    ) as Record<any, any[]>;
    return {
      [VariableType.EVENT_VARIABLE]: events,
      [VariableType.PREVIOUS_EVENT_VARIABLE]: previousEvents,
      ...enrichmentVariables,
    };
  };

  private renderAttachments = () => {
    const { attachments } = this.state;
    return (
      <div className={'flex flex-col w-full h-full mb-5 overflow-scroll'}>
        {attachments.map((attachment, index) => {
          return (
            <div className={'flex gap-x-5 w-full items-center justify-start px-5 py-2 border-b last:border-none first:border-b '} key={index}>
              <span className={'flex w-full px-2'} data-testid={`${ComponentName.RULE}_attachment_${attachment.name}_key_text`}>
                {attachment.name}
              </span>

              <span className={'flex w-full px-2'} data-testid={`${ComponentName.RULE}_attachment_${attachment.name}_value_text`}>
                {attachment.expression}
              </span>
              <span
                onClick={(e) => this.removeAttachment(e, attachment)}
                className='flex items-center shrink-0 justify-center cursor-pointer text-lg border-[1px] border-[#E0E4E8] rounded  h-8 w-8'
                data-testid={`${ComponentName.RULE}_attachment_${attachment.name}_remove_button`}
              >
                <Icon icon={'delete'} size={20} className={'text-primary'} />
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  private handleKeyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ attachmentKey: event.target.value });
  };

  private handleValueChange = (value: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ attachmentValue: value.target.value });
  };

  private editKeyChange = async (event: React.ChangeEvent<HTMLInputElement>, attachment: RuleAttachment) => {
    const { attachments } = this.state;
    attachment.name = event.target.value;
    this.setState({ attachments: attachments });
  };

  private editValueChange = async (event: React.ChangeEvent<HTMLInputElement>, attachment: RuleAttachment) => {
    const { attachments } = this.state;
    attachment.expression = event.target.value;
    this.setState({ attachments: attachments });
  };

  private attachmentSaved = () => {
    const { attachments } = this.state;
    const { onChangeResolution } = this.props;
    onChangeResolution(attachments);
  };

  private handleAddAttachment = () => {
    const { attachmentKey, attachmentValue, attachments } = this.state;
    const { onChangeResolution } = this.props;
    if (attachmentKey && attachmentValue) {
      const attachmentKeyExists = attachments.some((attachment) => attachment.name === attachmentKey);
      if (attachmentKeyExists) return;
      const newAttachment: RuleAttachment = {
        name: attachmentKey,
        expression: attachmentValue,
      };
      attachments.push(newAttachment);
      this.setState(
        {
          attachments: attachments,
          attachmentKey: '',
          attachmentValue: '',
        },
        () => onChangeResolution(attachments),
      );
    }
  };

  private handleRemoveAttachment = (attachment: RuleAttachment) => {
    const { attachments } = this.state;
    const { onChangeResolution } = this.props;

    const index = attachments.indexOf(attachment);
    if (index != -1) {
      attachments.splice(index, 1);
    }
    this.setState({ attachments: attachments }, () => onChangeResolution(attachments));
  };

  private removeAttachment = async (e: any, attachment: RuleAttachment) => {
    customConfirm({
      target: e.currentTarget,
      accept: async () => {
        this.handleRemoveAttachment(attachment);
      },
      message: LanguageUtil.get({ id: 'messages.confirm.confirmRemove', defaultMessage: 'Are you sure you want to remove?' }),
    });
  };
}

interface Props extends ReduxProps {
  selectedResolution: CaseReason;
  onChangeResolution: (attachments: RuleAttachment[]) => void;
}

const mapStateToProps = (state: RootState) => ({
  rule: state.rule,
});
const mapDispatchToProps = {};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  attachments: Array<RuleAttachment> = [];
  attachmentKey: string = '';
  attachmentValue: string = '';
  variables: Record<string, TokenVariable[]> = {};
  loading: boolean = true;
}

export default connector(ResolutionEditorComponent);
